import { setShowLogoutAlert, updateUserState } from '../store/auth/actions';
import { decrypt } from './crypto.helper';
import store from '../store';
import { getCookie, setCookie } from './cookie.helper';
import API from './API';
import constants from './constants';

export const refreshAuthToken = async () => {
  try {
    const response = await API.post('/refresh-token');
    if (response.data.success) {
      const newToken = response.data.data.token;
      return newToken;
    } else {
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    console.error('Failed to refresh token', error);
    throw error;
  }
};

export const initializeUserState = () => {
    const userCookieData = getCookie("_u0_");
    if (userCookieData) {
      const userData = JSON.parse(decrypt(userCookieData));
      store.dispatch(updateUserState(userData));
    }
};

export const getDefaultPageByRole = (navigate) => {
  const userCookieData = getCookie("_u0_");
  const userData = JSON.parse(decrypt(userCookieData));
  const role_code = userData.role.role_code;

  if(role_code === "SYSADM") {
    navigate('/users');
  } else if(role_code === "ADM") {
    navigate('/users');
  } else {
    navigate('/dashboard');
  }
  // navigate('/home');

}

export const checkAndRefreshToken = async () => {
  // Cookie-based (normal browser)
  const cookieToken = getCookie('authToken');
  const cookieExpiration = getCookie('authTokenExpiration');

  const now = Date.now();

  if (cookieToken && cookieExpiration) {
    if (now >= cookieExpiration) {
      try {
        const newToken = await refreshAuthToken(); // should use cookie automatically
        const authTokenExpiration = now + constants.auth.accessTokenExpiryIntervalDuration;

        setCookie('authToken', newToken, constants.auth.refreshTokenDuration);
        setCookie('authTokenExpiration', authTokenExpiration, constants.auth.refreshTokenDuration);

        return newToken;
      } catch (err) {
        console.error("Failed to refresh cookie-based token", err);
        store.dispatch(setShowLogoutAlert(true));
        return null;
      }
    } else {
      return cookieToken;
    }
  }

  // Header-based (incognito/sessionStorage)
  const sessionToken = sessionStorage.getItem("accessToken");
  const sessionExpiration = sessionStorage.getItem("accessTokenExpires");
  const refreshToken = sessionStorage.getItem("refreshToken");

  if (sessionToken && sessionExpiration && refreshToken) {
    if (now >= sessionExpiration) {
      try {
        const response = await API.post("/refresh-token", null, {
          headers: {
            "x-refresh-token": refreshToken
          }
        });

        const { token, expiresIn } = response.data.data;

        sessionStorage.setItem("accessToken", token);
        sessionStorage.setItem("accessTokenExpires", now + expiresIn * 1000);

        return token;
      } catch (err) {
        console.error("Failed to refresh session-based token", err);
        store.dispatch(setShowLogoutAlert(true));
        return null;
      }
    } else {
      return sessionToken;
    }
  }

  // No token found
  return null;
};

/* export const setupUserActivityListeners = () => {
    const userActivityHandler = () => {
        checkAndRefreshToken();
    };

    document.addEventListener("click", userActivityHandler);
    document.addEventListener("keydown", userActivityHandler);
}; */

export const isIncognito = async () => {
  const fs = window.RequestFileSystem || window.webkitRequestFileSystem;

  if (fs) {
    // Chrome & Edge (based on Chromium)
    return new Promise((resolve) => {
      fs(window.TEMPORARY, 100, () => resolve(false), () => resolve(true));
    });
  } else if (navigator.storage && navigator.storage.estimate) {
    // Firefox & Chromium-based fallback
    const { quota } = await navigator.storage.estimate();
    return quota < 120000000; // Less than 120MB likely means incognito
  } else if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
    // Safari Private Mode (throws error on localStorage or openDB)
    try {
      window.openDatabase(null, null, null, null);
      return false;
    } catch (e) {
      return true;
    }
  } else {
    // Unknown or not detectable
    return null;
  }
}